import {RouteLocationRaw} from "vue-router";
import {computed} from "vue";

export interface BaseRouteAttributes {
  href?: string;
  to?: RouteLocationRaw;
}

export const useRouteAttributes = <T extends BaseRouteAttributes>(props: T, defaultRoute: RouteLocationRaw | null = null) => {
  return computed((): BaseRouteAttributes => {
    if (props.href) {
      return {
        href: props.href,
      };
    }

    if (!props.to) {
      if (defaultRoute) {
        return {
          to: defaultRoute
        }
      }

      return {};
    }

    return {
      to: props.to
    };
  });
}
